import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination, Controller, EffectFade, Autoplay } from 'swiper/core';

SwiperCore.use([Navigation, Pagination, Controller, EffectFade, Autoplay]);

const config = {
    // CSS class names
    containerModifierClass: 'c-slideshow__container--',
    wrapperClass: 'js-slideshow__list',
    slideClass: 'js-slideshow__item',
    slideVisibleClass: 'h-is-visible',
    slideBlankClass: 'is-blank',
    slidePrevClass: 'is-previous',
    slideActiveClass: 'is-active',
    slideNextClass: 'is-next',

    // Options
    watchOverflow: true,

    // effect: 'slide', // "slide", "fade", "cube", "coverflow" or "flip"
    // speed: 800,
    grabCursor: true,

    // loop: false,
    // slidesPerView: 1,
    // autoplay: true,


    // Add pagination bullets and show current slide fraction
    pagination: {
        type: 'bullets', // "bullets", "fraction", "progressbar" or "custom"
        clickable: false,

        // CSS selector or DOM element
        el: '.js-slideshow__status',

        // CSS class names
        modifierClass: 'c-slideshow__status--',
        clickableClass: 'c-slideshow__status--clickable',
        hiddenClass: 'is-hidden',
        lockClass: 'is-disabled',
        bulletActiveClass: 'c-slideshow__bullet--is-active',
        bulletClass: 'c-slideshow__bullet',
        currentClass: 'c-slideshow__status__is-current',
        totalClass: 'c-slideshow__fraction-total',
    },

    // Add previous/next buttons
    navigation: {
        // CSS selector or DOM element
        prevEl: '.js-slideshow__arrow--previous',
        nextEl: '.js-slideshow__arrow--next',

        // CSS class names
        disabledClass: 'is-disabled',
        hiddenClass: 'is-hidden',
        lockClass: 'is-locked',
    },

    a11y: {
        enabled: true,
        notificationClass: 'c-slideshow__live-region',
        prevSlideMessage: 'prevSlideMessage: Previous slide',
        nextSlideMessage: 'nextSlideMessage: Next slide',
        firstSlideMessage: 'firstSlideMessage: This is the first slide',
        lastSlideMessage: 'lastSlideMessage: This is the last slide',
        paginationBulletMessage: 'paginationBulletMessage: Go to slide {{index}}',
        containerMessage: 'containerMessage',
        containerRoleDescriptionMessage: 'Group?', // TODO: check aria specs for correct role
        itemRoleDescriptionMessage: 'Item?', // TODO: check aria specs for correct role
    },
    on: {
        init: function (swiper) {
            // ARIA-Labels für Buttons setzen
            document.querySelector('.js-slideshow__arrow--previous').setAttribute('aria-label', 'Zur vorherigen Folie');
            document.querySelector('.js-slideshow__arrow--next').setAttribute('aria-label', 'Zur nächsten Folie');

            // Pagination-Buttons nachträglich mit ARIA-Labels versehen
            setTimeout(() => {
                document.querySelectorAll('.c-slideshow__bullet').forEach((bullet, index) => {
                    bullet.setAttribute('aria-label', `Gehe zu Folie ${index + 1}`);
                    bullet.setAttribute('role', 'button');
                });
            }, 100);

            // Direkt den ersten Bullet mit `aria-current="true"` markieren
            let activeBullet = document.querySelector('.c-slideshow__bullet--is-active');
            if (activeBullet) activeBullet.setAttribute('aria-current', 'true');
        },

        slideChange: function (swiper) {
            // Alle Pagination-Bullets `aria-current` entfernen
            document.querySelectorAll('.c-slideshow__bullet').forEach((bullet) => {
                bullet.removeAttribute('aria-current');
            });

            // Neuen aktiven Bullet finden und `aria-current="true"` setzen
            let newActiveBullet = document.querySelector('.c-slideshow__bullet--is-active');
            if (newActiveBullet) newActiveBullet.setAttribute('aria-current', 'true');
        },
    },
};

class Slideshow {
    constructor($node, index, $nodeList) {
        this.$node = $node;
        this.index = index;
        this.$nodeList = $nodeList;
        this.showFractions = false;
        this.initalLength = this.$node.querySelectorAll('.js-slideshow__item').length;
        this.fractions = $node.querySelector('.c-slideshow__fraction');

        this.className = `js-slideshow-${this.index + 1}`;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.controlBtn = $node.querySelector('.js-slideshow__control-btn')

        /*
        this.options = JSON.parse(this.$node.dataset.slideshow);
        this.config = this.options.length
            ? Object.assign(this.options, config)
            : config;
        */
        if (this.$node.dataset.slideshow !== undefined) {
            const thisSwiperConfig = JSON.parse(this.$node.dataset.slideshow);
            if (window.innerWidth < 480 && thisSwiperConfig.autoplay !== false) {
                thisSwiperConfig.autoplay = false;
            }

            const mergedSwiperConfig = Object.assign(thisSwiperConfig, config);
            this.config = mergedSwiperConfig;
        } else {
            this.config = config;
        }

        this.instances = [];
        this.fraction = '';
        this.swiper;

        // this.onResize = this.onResize.bind(this);
        this.appendFraction = this.appendFraction.bind(this);
    }

    init() {
        if (!this.$node) {
            return;
        }

        this.$node.classList.add(this.className);

        // check for reduced motion and set autoplay to false
        if (this.reducedMotion.matches) {
            this.config.autoplay = false;
            this.$node.classList.add('c-slideshow__container--reducedMotion');
            
        }



        this.swiper = new Swiper(`.${this.className}`, this.config);

        if (this.showFractions) {
            this.appendFraction();
            this.swiper.on('slideChange', this.appendFraction);
        }

        // add control btn handler if autoplay active
        if (this.controlBtn && this.config.autoplay === true){
            this.swiper.autoplay.disableOnInteraction = false;
            this.controlBtn.addEventListener('click', (e) => this.controlAutoplay(e))
        }
        else {
            if (this.controlBtn){
                this.controlBtn.style.display = "none";
            }
        }

        // window.addEventListener('resize', this.onResize);
    }

    controlAutoplay(){

        if (this.controlBtn.getAttribute("aria-checked") === "true"){
            this.swiper.autoplay.run()
            this.controlBtn.ariaLabel = "Autoplay anhalten"
            this.controlBtn.setAttribute("aria-checked", "false");
        }

        else {
            this.swiper.autoplay.pause();
            this.controlBtn.ariaLabel = "Autoplay starten"
            this.controlBtn.setAttribute("aria-checked", "true");
        }

    }

    disableAutoplayMobile() {}

    appendFraction() {
        if (this.fractions) {
            this.fractions.textContent = `${this.swiper.realIndex + 1} / ${this.initalLength}`;
        }
    }
}

export default Slideshow;
